import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p><a href="https://simonrose.software" target="_blank">{`Simon Rose Software
`}</a>
      {` is a static website to advertise my freelance software engineering business.
It is built using `}
      <a href="https://nuxtjs.org/" target="_blank">{`
Nuxt.js
`}</a>
      {` and hosted on Google Firebase. It uses a Firebase function for the email sending
(so as to keep the site static) and `}
      <a href="https://tailwindcss.com/" target="_blank">{`Tailwind`}</a>
      {` for CSS.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      